import classes from "./SlideShowKiosk.module.css";
import axios from "axios";
import { path, assetsBaseUrl } from "../../../../routes";
import {useEffect, useState} from "react";
import arr from "../../../../store/link.jpg"

const SlideShowKiosk_redesign_harr = (props) => {

    const [cards, setCards] = useState([])
    const [group, setGroup] = useState(props.groupID)
    const [currentIndexA, setCurrentIndexA] = useState(0);
    const setObje = (x) => {
        let fld = []
        for (let i = 0; i < x.length; i++) {
            const id = x[i].id
            try {
                let temp = {
                    id: id,
                    Header: x[i].description,
                    CreatedBy: x[i].username,
                    Body: {
                        file: x[i].path,
                        //imgURL: `https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png`,//fileContent,
                        imgURL: assetsBaseUrl + x[i].path
                    }
                }
                fld.push(temp)
            } catch (error) {
                console.error('Fetching elevators Error:', error.message);
            }
        }
        console.log(fld)
        setCards([...fld])
    }

    const fetchDataCards = async (gr) => {
        try {
            const response = await axios.get(`${path}/getCardsV3?orgID=306F8ACA-52B0-443E-9404-12BD242FF7C5&group=${gr}&onlyVisible=1`);
            console.log(response.data);
            // Optionally, update your UI to reflect the deletion
            setObje(response.data)
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexA((prevIndex) => (prevIndex + 1) % cards.length);
        }, 15000);
        return () => {
            clearInterval(intervalId);
        };
    }, [cards]);
    useEffect(() => {
        console.warn("ajojda")
        fetchDataCards(group)
    }, [])

    const  backHandler = () => {
        currentIndexA == 0?setCurrentIndexA(cards.length-1):setCurrentIndexA(currentIndexA-1)
    }
    const  nextHandler = () => {
        currentIndexA == cards.length-1?setCurrentIndexA(0):setCurrentIndexA(currentIndexA+1)
    }
    return <div className={classes.mainRed}>
        {cards.length != 0 && <img className={classes.imageRed} src={cards[currentIndexA].Body.imgURL} alt={"logo"}/>}
    </div>
}
export default SlideShowKiosk_redesign_harr